import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-8 px-12 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "flex items-center mb-6 space-x-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:space-x-8" }
const _hoisted_4 = { class: "w-3/4 md:w-3/4 space-y-6" }
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = { class: "w-1/2" }
const _hoisted_7 = { class: "w-1/2" }
const _hoisted_8 = { class: "w-[450px] mt-6 md:mt-0" }
const _hoisted_9 = { class: "space-y-4" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddStatus = _resolveComponent("AddStatus")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_cancel_return = _resolveComponent("cancel-return")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "text-brand-600 hover:text-brand-800"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Back to jobs")
        ])),
        _: 1
      }),
      _cache[9] || (_cache[9] = _createElementVNode("span", null, "|", -1)),
      _createVNode(_component_router_link, {
        to: `/view/${$setup.jobData.id}`,
        class: "text-brand-600 hover:text-brand-800"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("View Job")
        ])),
        _: 1
      }, 8, ["to"])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "text-3xl font-bold mb-8" }, "Edit Job", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.saveChanges && $setup.saveChanges(...args)), ["prevent"])),
      class: "space-y-6"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "jobTitle",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Title", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "jobTitle",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.jobData.title) = $event)),
              required: "",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
            }, null, 512), [
              [_vModelText, $setup.jobData.title]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "company",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Company", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "company",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.jobData.company) = $event)),
              required: "",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
            }, null, 512), [
              [_vModelText, $setup.jobData.company]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "jobUrl",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Job URL", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "url",
              id: "jobUrl",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.jobData.job_url) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
            }, null, 512), [
              [_vModelText, $setup.jobData.job_url]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                for: "salaryRange",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Salary Range", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "salaryRange",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.jobData.salary_range) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
              }, null, 512), [
                [_vModelText, $setup.jobData.salary_range]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "applicationDate",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Application Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "applicationDate",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.jobData.application_date) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
              }, null, 512), [
                [_vModelText, $setup.jobData.application_date]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              for: "description",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Description", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.jobData.description) = $event)),
              rows: "10",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
            }, null, 512), [
              [_vModelText, $setup.jobData.description]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-xl font-semibold mb-3" }, "Process Steps", -1)),
          ($setup.jobData.latest_process_type !== 'Rejected')
            ? (_openBlock(), _createBlock(_component_AddStatus, {
                key: 0,
                "current-status": $setup.jobData.status,
                statuses: $setup.statuses,
                "status-date": $setup.statusDate,
                onUpdateStatus: $setup.updateStatus
              }, null, 8, ["current-status", "statuses", "status-date", "onUpdateStatus"]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobData.process_steps, (step) => {
              return (_openBlock(), _createElementBlock("li", {
                key: step.id,
                class: "flex items-center space-x-4"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": ($event: any) => ((step.process_date) = $event),
                  class: "px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
                }, null, 8, _hoisted_10), [
                  [_vModelText, step.process_date]
                ]),
                _createElementVNode("span", null, _toDisplayString(step.process_type), 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => ($setup.removeProcessStep(step.id)),
                  type: "button",
                  class: "text-red-600 hover:text-red-800"
                }, "Remove", 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_BaseButton, {
          type: "submit",
          text: "Update"
        }),
        _createVNode(_component_cancel_return, {
          text: "Cancel",
          onClick: $setup.cancel
        }, null, 8, ["onClick"])
      ])
    ], 32)
  ]))
}